import { find } from "ramda";

export default function getLocaleToCreateContent(structure) {
  let value = "";
  if (structure) {
    const objectValue = find((v) => v.value === structure.name, structure?.nameTranslatable?.value);
    value = objectValue.key;
  }
  return value;
}
